// @flow

import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const MultipleActionsDialog = ({
  open,
  title,
  message,
  loadingText,
  loading,
  error,
  errorText,
  cancelText,
  onCancel,
  primaryText,
  primaryColor,
  onPrimary,
  secondaryText,
  secondaryColor,
  onSecondary,
  dialogProps,
}) => {
  return (
    <Fragment>
      <Dialog {...dialogProps} open={Boolean(open)} fullWidth maxWidth={'md'}>
        <DialogTitle>
          {loading && loadingText}
          {!loading && title}
        </DialogTitle>

        <DialogContent style={{ overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading ? (
              <CircularProgress size={80} thickness={5} />
            ) : (
              <Fragment>
                {error ? (
                  <Box
                    sx={{
                      mb: 1,
                    }}
                  >
                    {errorText}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      mb: 1,
                    }}
                  >
                    {message}
                  </Box>
                )}
              </Fragment>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {!loading && (
            <Fragment>
              <Button
                data-testid="multiple-actions-dialog-cancel"
                onClick={onCancel}
                color={'inherit'}
                variant={'outlined'}
              >
                {cancelText ? cancelText : 'Cancel'}
              </Button>

              {error ? (
                <Button onClick={onCancel} color={'secondary'} variant={'contained'}>
                  {cancelText ? cancelText : 'Cancel'}
                </Button>
              ) : (
                <Fragment>
                  <Button
                    onClick={onSecondary}
                    color={secondaryColor ? secondaryColor : 'inherit'}
                    variant={'outlined'}
                  >
                    {secondaryText ? secondaryText : ''}
                  </Button>
                  <Button
                    onClick={onPrimary}
                    color={primaryColor ? primaryColor : 'primary'}
                    variant={'contained'}
                  >
                    {primaryText ? primaryText : ''}
                  </Button>
                </Fragment>
              )}
            </Fragment>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(MultipleActionsDialog);

MultipleActionsDialog.propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  dialogProps: PropTypes.object,
};
